// Web-side wiring for @racefriends/shared. Imported for its side effect by
// lib/pocketbase.ts BEFORE getPb() runs, so module evaluation order
// guarantees the shared config exists when the client is created.
import * as Sentry from '@sentry/nextjs';
import { configureShared } from '@racefriends/shared/config';

configureShared({
  pocketbaseUrl: process.env.NEXT_PUBLIC_POCKETBASE_URL ?? '',
  liveServerUrl: process.env.NEXT_PUBLIC_LIVE_SERVER_URL ?? '',
  webApiUrl: '',
  reportError: (error, context) => {
    Sentry.captureException(error, context ? { extra: context } : undefined);
  },
  capture: (event, properties) => {
    // Dynamic import breaks the cycle posthog-client -> lib/pocketbase -> here.
    import('./posthog-client')
      .then((mod) => mod.capturePosthogEvent(event, properties))
      .catch(() => {});
  },
});
